import ConfigLOCAL from './local.json';
import ConfigDEV from './dev.json';
import ConfigTI from './ti.json';
import ConfigTEST from './test.json';
import ConfigPP from './pp.json';
import ConfigPROD from './prod.json';
import { loadItem } from '../utils';
import { Nullable } from 'types/interfaces';
import { getConfigType } from './utils';

interface IDocumentGeneratorConfigs {
  BASE_URL: string;
  BASE_DOC_URL: string;
  ENDPOINTS: {
    DOCUMENT: string;
    DOCUMENT_MERGED: string;
  };
}

interface ITermsAndConditionsUrls {
  ACCOUNT_AGREEMENTS: string;
  LEGAL_AND_REGULATORY_DOCUMENTS: string;
}

interface IExternalUrls {
  TERMS_AND_CONDITIONS: {
    EN: ITermsAndConditionsUrls;
    FR: ITermsAndConditionsUrls;
  };
}

interface ICaptchaConfigs {
  SITE_KEY_FRONTEND: string;
  SITE_KEY_SAFEID: string;
  SITE_KEY_TYPE_FRONTEND: string;
  SITE_KEY_TYPE_SAFEID: string;
  GOOGLE_ENDPOINT: string;
  EXCHANGE_TOKEN_ENDPOINT: string;
}

interface FeatureToggleConfig {
  SSO: boolean;
  IAMX_ENCRYPTION: boolean;
  IS_RECAPTCHA_ENABLED: boolean;
  RUM_ENABLED: boolean;
}

interface RumConfig {
  applicationId: string;
  clientToken: string;
  site: string;
  service: string;
  env: string;
  version: string;
  sessionSampleRate?: number;
}

export type ConfigType = {
  [key: string]: any;
  DOCUMENTS_GENERATOR_SERVER: IDocumentGeneratorConfigs;
  EXTERNAL_URLS: IExternalUrls;
  CAPTCHA: ICaptchaConfigs;
  FEATURE_TOGGLE: FeatureToggleConfig;
  RUM: RumConfig;
};

export const getConfig = (env: Nullable<string> = null): ConfigType => {
  const currentEnv = loadItem('DEV_ENV') || env;

  switch (currentEnv) {
    case 'local':
      return ConfigLOCAL;
    case 'dev':
      return ConfigDEV;
    case 'ti':
      return ConfigTI;
    case 'test':
      return ConfigTEST;
    case 'pp':
      return ConfigPP;
    case 'prod':
      // Determine whether we need the real production configurations (common, using production urls),
      //  or the production configurations used on local environments and tests (prod, using secured zone urls)
      return ConfigPROD;
    default:
      return getConfigType();
  }
};

class Config {
  private _params: ConfigType | null = null;

  get params(): ConfigType {
    if (!this._params) {
      this._params = getConfig();
    }
    return this._params;
  }

  set params(value: ConfigType) {
    this._params = value;
  }

  init(env: string): ConfigType {
    this._params = getConfig(env);
    return this._params;
  }
}

export default new Config();
